import { render, staticRenderFns } from "./IconPage.vue?vue&type=template&id=cbdc2d56&"
import script from "./IconPage.vue?vue&type=script&lang=js&"
export * from "./IconPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbdc2d56')) {
      api.createRecord('cbdc2d56', component.options)
    } else {
      api.reload('cbdc2d56', component.options)
    }
    module.hot.accept("./IconPage.vue?vue&type=template&id=cbdc2d56&", function () {
      api.rerender('cbdc2d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPage.vue"
export default component.exports